if (!customElements.get('sahara-add-ons')) {
  customElements.define('sahara-add-ons', class extends HTMLElement {
    connectedCallback() {
      const currency = this.dataset.currency;
      const rate = currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
      if (this.dataset.baseCurrency !== 'USD' || !Number.isFinite(rate) || rate <= 0) {
        this.hidden = true;
        return;
      }
      let count = 0;
      for (const item of this.querySelectorAll('[data-addon-price]')) {
        const dollars = Number(item.dataset.addonPrice) / rate / 100;
        item.hidden = !(dollars >= 7.98 && dollars <= 19.02 && count < 4);
        if (!item.hidden) count += 1;
      }
      this.hidden = count === 0;
    }
  });
}
